export default __webpack_public_path__ + "static/media/41.526d6fcf.png";